import { render, staticRenderFns } from "./Searchbar.vue?vue&type=template&id=4c8a7d2e&scoped=true"
import script from "./Searchbar.vue?vue&type=script&lang=ts"
export * from "./Searchbar.vue?vue&type=script&lang=ts"
import style0 from "./Searchbar.vue?vue&type=style&index=0&id=4c8a7d2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8a7d2e",
  null
  
)

export default component.exports